import { useState, useRef } from 'react';

export const useSubmitHandler = (submitFunction, onSuccess, onError) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isSubmittingRef = useRef(false);
    const [formError, setFormError] = useState(null);

    const handleSubmit = async (formData, e) => {
        if (e && e.preventDefault) e.preventDefault();
        
        if (isSubmittingRef.current) return;
        isSubmittingRef.current = true;
        setIsSubmitting(true);
        setFormError(null);

        try {
            const result = await submitFunction(formData);

            if (result.success) {
                if (onSuccess) onSuccess(result.data);  // Callback untuk sukses dengan data
            } else {
                if (result.errorResponse?.code === 422) {
                    setFormError(result.errorResponse.message);  // Error validation
                } else {
                    if (onError) onError();  // Callback untuk error
                }
            }
        } finally {
            isSubmittingRef.current = false;
            setIsSubmitting(false);
        }
    };

    return { handleSubmit, isSubmitting, formError };
};
